export default {"src":"/_next/static/image/public/images/flags/flag_960.480d3528fd7c415e7cf1a3925a5ef716.svg","height":16,"width":24};